import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import { compose } from 'recompose';
import { noCapMap } from '../../utils';

const getProgress = (currentStep, totalSteps) => (currentStep * 100) / (totalSteps - 1)

const Wizard = ({
  config: {
    currentStep,
    steps,
    data
  },
}) => {
  const {
    title,
    footer,
    component
  } = steps[currentStep]

  const hasLongSteps = steps.length > 3

  return (<div id='wizard'>
    <Grid>
      <Row className='no-gutter'>
        <Col xs={12} md={hasLongSteps ? 6 : 9} className='no-padding' id='heading'>
          {title}
        </Col>
        <Col xs={hasLongSteps ? 12 : 6} xsOffset={hasLongSteps ? 0 : 3} md={hasLongSteps ? 6 : 3} mdOffset={0} className='no-padding' id='progress'>
          <ProgressBar percent={getProgress(currentStep, steps.length)}>
            {
              noCapMap(
                (step, stepId) => (<Step key={stepId}>
                  {({ index }) => (
                    <div
                      className={`indexedStep ${stepId < currentStep ? "accomplished" : stepId === currentStep ? "in-progress" : null}`}
                    >
                      <div className='progress-text'>
                        {step.name}
                      </div>
                    </div>
                  )}
                </Step>)
              )(steps)
            }
          </ProgressBar>
        </Col>
      </Row>
      {
        <Row className='no-gutter'>
          <Col xs={12} className='no-padding' id='step'>{component}</Col>
        </Row>
      }
      {
        <div id='footer' className='boxed'>{footer}</div>
      }
    </Grid>
  </div>)
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({})

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(Wizard)


// WEBPACK FOOTER //
// ./src/containers/components/wizard.js